export const getBonusMyAwardListSWRKey = (
  token?: string | null,
  isLogin = false
): string | null => {
  return isLogin && token ? `bonusAwardList?${token}` : null;
};
